import React, { FC } from 'react'

import { IconAdminProps } from './IconAdmin.types'
import * as Styled from './styles/IconAdmin.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAdmin: FC<IconAdminProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAdminProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconAdminProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M144 147.52c-5.61-38-25.17-57.3-45.09-64.39a40 40 0 1 0-37.55.09 60.42 60.42 0 0 0-21.4 13.42c-12.47 12-20.73 29.6-23.87 50.86a4 4 0 1 0 7.91 1.17c6.64-44.88 34.53-60.8 56.4-60.8a49.29 49.29 0 0 1 34.52 14.52c11 10.74 18.28 26.75 21.17 46.3a4 4 0 0 0 7.91-1.17zM48 47.87a32 32 0 1 1 32 32 32 32 0 0 1-32-32z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAdmin
